import React from "react";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import MuestraForm from "../components/visits/MuestraForm";
import FotosVisita from "../components/visits/FotosVisita";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import HojaRemisionMuestra from "../components/content/visits/hoja_remision_muestra";
import classnames from "classnames";
import Swal from "sweetalert2";

class Visits extends React.Component {
  initialState = {
    modalActa: false,
    previa: false,
    fotoVisitaVertical: true,
    workingModal: true,
    modalMuestraState: false,
    folio_visita: "",
    openCarousel: false,
    nivelUsuario: localStorage.nivel_actual,
    modalHojaRemisionMuestra: false,
    previa_url: "",
    locations: Api.loadCatalogue("locations"),
    municipios: [],
    opciones_pais: Api.loadCatalogue("countries"),
    cat_actividad: Api.loadCatalogue("cat_actividad"),
    cat_tipo_encuesta: Api.loadCatalogue("cat_tipo_encuesta"),
    acta_info: {
      id: "",
      nombre_razon: "",
      folio: "",
      direccion: "",
      hora_fin: "",
      fecha: "",
      tipo_encuesta_id: "",
      actas_destruccion: [],
      actas_productos: [],
      inspectores: [],
    },
    encuesta_info: {
      id: "",
      nombre_razon: "",
      direccion: "",
      telefono: "",
      email: "",
      nombre_atiende: "",
      cargo_atiende: "",
      fecha: "",
      tipo_inspeccion_nombre: "",
      lugar: "",
      pais_texto: "",
      municipio_id: "",
      departamento_id: "",
      tipo_encuesta: "",
      folio_establecimiento: "",
      folio: "",
      regentes: [],
      representantes: [],
      encuesta: "",
      inspeccion: "",
      inspectores: [],
      tipo_produccion: [],
      materia_prima: [],
      subproducto: [],
      especies: [],
      detalles: [],
      departamento: "",
      municipio: "",
      porc_exp_nica: "",
      vol_mensual: "",
      vol_semanal: "",
      longitud: "",
      latitud: "",
      hora_inicio: "",
      hora_fin: "",
      regente_info: "",
      lista_encuesta: [],
      actividad: "",
    },
    analisis_info: {
      id: "",
      folio: "",
      tipo_encuesta_id: "",
      codigo_muestra: "",
      detalles: [],
      fecha: "",
      no_lote: "",
      forma_farmceutica: "",
      producto_info: "",
      especies_destino: [],
      categorias: [],
      materia_prima_texto: "",
      sales_texto: "",
      otros_texto: "",
      nombre_razon: "",
      municipio: "",
      departamento: "",
      tipo_muestra: "",
      forma_comercializacion: "",
      nombre_representante: "",
      nombre_recibe_laboratorio: "",
      pais_texto: "",
      dropdownOpen: false,
      analisis_resultado: [],
      inspectores: [],
      motivo_remision: [],
      prueba_motivo: [],
    },
    laboratorio: "",
    cat_laboratorio: Api.loadCatalogue("cat_laboratorio"),
    rel_remision_visita_muestra: {
      visita_id: "",
      laboratorio_id: "",
      no_remision: "",
      //no_recibo: "",
      fecha_remision: "",
      hora_remision: "",
      fecha_vencimiento: "",
      //monto: "",
      clasificacion_zootecnica: "",
      //temperatura_ingreso: "",
      no_muestras: "",
      proposito: "",
      lote: "",
      marchamos: "",
      //temperatura_levantamiento: "",
      nombre_retiro: "",
      fecha_retiro: "",
      nombre_entrega: "",
      //fecha_ingreso: "",
      //hora_ingreso: "",
      id_mx: "",
      observaciones: "",
      fecha_prod_elab: "",
      //no_solicitud: "",
      comarca: "",
      otro_propietario: "",
      fecha: "",
      hora_inicio: "",
      cue_cod_ipsa: "",
      lugar_muestreo: "",
    },
    remisionMuestra: {
      id: "",
      visita_id: "",
      laboratorio_id: "",
      no_remision: "",
      fecha_remision: "",
      hora_remision: "",
      marchamos: "",
      //fecha_ingreso: "",
      //hora_ingreso: "",
      fecha_vencimiento: "",
      //no_recibo: "",
      //monto: "",
      clasificacion_zootecnica: "",
      proposito: "",
      temparatura_levatamiento: "",
      //temperatura_ingreso: "",
      lote: "",
      no_muestras: "",
      fecha_retiro: "",
      nombre_retiro: "",
      nombre_entrega: "",
      user_id: "",
      status: "",
      created: "",
      modified: "",
      tipo_muestra: "",
      forma_comercializacion: "",
      especies: "",
      categorias: "",
      analisis_solicitados: "",
      remitente: "",
      solicitante: "",
      colector: "",
      vdt2: "",
      visita: "",
      laboratorio: {},
      rel_remision_visita_muestra: {},
      fecha_prod_elab: "",
      //no_solicitud: "",
      comarca: "",
      otro_propietario: "",
      fecha: "",
      hora_inicio: "",
      cue_cod_ipsa: "",
      lugar_muestreo: "",
      nombre_razon: "",
    },
    fotosVisita: [],
    working: true,
    toggle: false,
    paginaActual: 0,
    paginaActual_vi: 0,
    paginas: 0,
    paginas_vi: 0,
    registros: 0,
    registros_vi: 0,
    visitas: [],

    activeTab: "1",
    buscar: {},
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
    ],
    visitas_internacionales: [],
    id_establecimiento: "",
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  regente = {};

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  getAnalisisResultadosData = (visita_id) => {
    Api.loading(true);
    Api.fetch("app/getAnalisisResultadosData?visita_id=" + visita_id).then(
      (data) => {
        Api.loading(false);
      }
    );
  };

  toggle = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  handleModalMuestraFormCloseBtn = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#4CD964",
      denyButtonColor: "red",
      denyButtonText: "Cancelar",
      confirmButtonText: "Aceptar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.resetStates();
      }
    });
  };

  closeCarousel = () => {
    this.resetStates();
  };

  closeModalHojaRemision = (e) => {
    e.preventDefault();
    this.resetStates();
  };

  resetStates = (e) => {
    this.setState({
      rel_remision_visita_muestra:
        this.initialState.rel_remision_visita_muestra,
      modalMuestraState: this.initialState.modalMuestraState,
      laboratorio: this.initialState.laboratorio,
      remisionMuestra: this.initialState.remisionMuestra,
      modalHojaRemisionMuestra: this.initialState.modalHojaRemisionMuestra,
      fotosVisita: this.initialState.fotosVisita,
      openCarousel: this.initialState.openCarousel,
      fotoVisitaVertical: this.initialState.fotoVisitaVertical,
    });
  };

  componentDidMount() {
    // si el usuario no es nivel inspector redireccionamos a home
    if (this.state.nivelUsuario !== "5") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.setVisitasPage(1);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch = (obj) => {
    // Si el obj.target.name pertenece a un input type text aplicamos la funcion
    // toUpperCase()
    ["folio", "folio_manual", "nombre_razon"].includes(obj.target.name)
      ? (this.search[obj.target.name] = obj.target.value.toUpperCase())
      : (this.search[obj.target.name] = obj.target.value);

    // si obj.target name pertenece a fecha, habilitamos la fecha2
    if (obj.target.name === "fecha") {
      document.getElementById("fecha2").removeAttribute("disabled");
      if (this.state.buscar.hasOwnProperty("fecha2")) {
        document.getElementById("fecha2").value = "";
        delete this.search["fecha2"];
      }
    }

    // filtramos municipios por el departamento_id
    if (obj.target.name === "departamento_id") {
      document.getElementById("municipio_id").value = "";
      document.getElementById("pais_id").value = "";
      delete this.search["municipio_id"];
      delete this.search["pais_id"];

      let result = this.state.locations.municipios.filter(
        (municipio) => municipio.estado_id === obj.target.value
      );

      this.setState({ municipios: result });
    }

    if (obj.target.name === "pais_id") {
      document.getElementById("departamento_id").value = "";
      document.getElementById("municipio_id").value = "";
      delete this.search["municipio_id"];
      delete this.search["departamento_id"];

      this.setState({ municipios: [] });
    }

    this.setState({ buscar: this.search });
  };

  modalInputFile = (e) => {
    let folio_visita = e.target.getAttribute("data-folio"),
      visita_id = e.target.id;

    Swal.fire({
      title:
        "<span style='font-weight: bold; font-size: large;'>Adjuntar archivo PDF a la visita con folio " +
        folio_visita +
        "</span>",
      input: "file",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Guardar",
      reverseButtons: true,
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      cancelButtonColor: "red",
      confirmButtonColor: "#4CD964",
      html: "<p style='color: #FF9300; font-size: small; font-weight: bold;'>Solo se permiten archivos en formato PDF***</p>",
      preConfirm: (file) => {
        if (!file) {
          Swal.showValidationMessage("Seleccione un archivo.");
          return false;
        }

        if (file.type.split("/")[1] !== "pdf") {
          Swal.showValidationMessage("Este tipo de documento no es admitido.");
          return false;
        }

        if (file.size >= 20000000) {
          Swal.showValidationMessage(
            "Se ha excedido de los 20MB permitidos de carga total."
          );
          return false;
        }

        return file;
      },
      allowOutsideClick: false,
    }).then((file) => {
      let fileReader = new FileReader();

      if (file.isConfirmed) {
        Api.loading(true);

        fileReader.onloadend = function (a) {
          let pdf = {
            data: fileReader.result,
            ext: file.value.type.split("/")[1],
            file: file.value.name,
            size: a.total,
            visita_id,
          };

          Api.fetch("app/updateURLPDF", pdf, "PUT").then((res) => {
            Swal.fire({
              title: "¡Archivo Guardado!",
              icon: "success",
              text: "Se ha guardado el archivo correctamente.",
            }).then((res) => (window.location.href = "/visitas"));
          });
        };
        fileReader.readAsDataURL(file.value);
      }
    });
  };

  handleLaboratoryChange = (obj) => {
    let muestraRemision = { ...this.state.rel_remision_visita_muestra };
    this.cleanErrorsValidation("laboratorio");

    muestraRemision.laboratorio_id = obj.id;

    this.setState({
      rel_remision_visita_muestra: muestraRemision,
      laboratorio: obj,
    });
  };

  openModalMuestraForm = (e) => {
    let folio_visita = e.target.getAttribute("data-folio"),
      muestraRemision = { ...this.state.rel_remision_visita_muestra };

    muestraRemision.visita_id = e.target.id;

    this.getAnalisisResultadosData(e.target.id);

    this.setState({
      modalMuestraState: true,
      workingModal: false,
      folio_visita: folio_visita,
      rel_remision_visita_muestra: muestraRemision,
    });
  };

  cleanSearch = () => {
    let search = this.state.buscar;

    for (const prop in search) {
      delete search[prop];
      document.getElementById(prop).value = "";

      if (prop === "fecha") {
        document.getElementById("fecha2").setAttribute("disabled", true);
      }
    }

    this.setState({ buscar: search, municipios: [] });
    this.setVisitasPage(1);
  };

  handleRemisionMuestraFormValidations = (errors) => {
    let targetName = null;
    for (const i in errors) {
      i !== "laboratorio" ? (targetName = i.split(".")[1]) : (targetName = i);

      document.getElementById(targetName + "-error").style.display = "block";
      document.getElementById(targetName + "-error").innerText = errors[i];
      document.getElementById(targetName).classList.add("is-invalid");
    }
  };

  desactivarVisita = (e) => {
    Swal.fire({
      title: `¿Está seguro de eliminar la visita con folio: ${e.target.getAttribute(
        "data-folio"
      )}?`,
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#4CD964",
      denyButtonColor: "red",
      denyButtonText: "Cancelar",
      confirmButtonText: "Aceptar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch("app/desactivarVisita", { visita_id: e.target.id }, "PUT")
          .then((data) => {
            Api.loading(false);
            Swal.fire({
              icon: "success",
              title: `¡La visita con folio: ${e.target.getAttribute(
                "data-folio"
              )} ha sido eliminada con éxito!`,
              confirmButtonText: "Continuar",
              timer: 3000,
            });
          })
          .then((res) => (window.location.href = "/visitas"));
      }
    });
  };

  handleClick_hmr = (e) => {
    Api.loading(true);
    Api.fetch("app/getRemisionMuestraInfo?visita_id=" + e.target.id).then(
      (data) => {
        this.setState({
          workingModal: false,
          modalHojaRemisionMuestra: true,
          remisionMuestra: data,
          folio_visita: e.target.getAttribute("data-folio"),
        });
        Api.loading(false);
      }
    );
  };

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  openCarousel = (e) => {
    Api.loading(true);
    Api.fetch("app/getFotosVisita?visita_id=" + e.target.id).then((data) => {
      if (data.length === 0) {
        Swal.fire({
          icon: "info",
          title: "¡Esta visita no cuenta con imágenes disponibles!",
          confirmButtonText: "Regresar",
          timer: 3000,
        });
      } else {
        this.setState({
          openCarousel: true,
          workingModal: false,
          fotosVisita: data,
          folio_visita: e.target.getAttribute("data-folio"),
        });

        Api.loading(false);
      }
    });
  };

  handleSubmitMuestraRemision = (e) => {
    e.preventDefault();

    let muestraRemisionData = { ...this.state };

    delete muestraRemisionData.acta_info;
    delete muestraRemisionData.activeTab;
    delete muestraRemisionData.analisis_info;
    delete muestraRemisionData.buscar;
    delete muestraRemisionData.cat_actividad;
    delete muestraRemisionData.cat_laboratorio;
    delete muestraRemisionData.cat_tipo_encuesta;
    delete muestraRemisionData.collapse;
    delete muestraRemisionData.encuesta_info;
    delete muestraRemisionData.folio_visita;
    delete muestraRemisionData.id_establecimiento;
    delete muestraRemisionData.locations;
    delete muestraRemisionData.modalActa;
    delete muestraRemisionData.modalMuestraState;
    delete muestraRemisionData.municipios;
    delete muestraRemisionData.opciones_pais;
    delete muestraRemisionData.paginaActual;
    delete muestraRemisionData.paginaActual_vi;
    delete muestraRemisionData.previa;
    delete muestraRemisionData.previa_url;
    delete muestraRemisionData.registros;
    delete muestraRemisionData.registros_vi;
    delete muestraRemisionData.toggle;
    delete muestraRemisionData.visitas;
    delete muestraRemisionData.visitas_internacionales;
    delete muestraRemisionData.working;
    delete muestraRemisionData.workingGrid;
    delete muestraRemisionData.workingModal;
    delete muestraRemisionData.paginas;
    delete muestraRemisionData.paginas_vi;

    Swal.fire({
      icon: "question",
      title: "¿Completar formulario?",
      text: "¡Asegúrese que los datos estén completados correctamente!",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch("app/storeMuestraRemision", muestraRemisionData, "POST").then(
          (data) => {
            if (data.errors) {
              this.handleRemisionMuestraFormValidations(data.errors);
              Api.loading(false);
              return false;
            } else {
              Api.loading(false);
              Swal.fire({
                icon: "success",
                title:
                  "¡Los datos de la remisión de muestra han sido almacenados correctamente!",
                confirmButtonText: "Continuar",
                timer: 3000,
              }).then(() => {
                window.location.href = "/visitas";
              });
            }
          }
        );
      }
    });
  };

  // funcion para validar que el usuario ingreso solo numeros en tipo float
  validateFloat = (str) => {
    // let regex = /^(-|)([0]?||[1-9]\d{0,2}(\d{3})*|([1-9]\d*))(\.\d{0,2})?$/,
    let regex = /^[0-9]*(?:\.[0-9]{0,3})?$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  // fn para cambiar la orientación de la imagen de vertical a horizontal y visceversa
  orientarImagen = (e) => {
    let imgs = document.querySelectorAll(".imgs-visita") || [];
    let rotadorBtn = document.getElementById("rotacion-img-btn");
    let modoImg = this.state.fotoVisitaVertical;

    imgs.forEach((img) => {
      if (modoImg) {
        img.style.transform = "rotate(90deg)";
        rotadorBtn.textContent = "Ver Imágen Vertical";
      } else {
        img.style.transform = "rotate(0deg)";
        rotadorBtn.textContent = "Ver Imágen Horizontal";
      }
    });

    this.setState({ fotoVisitaVertical: !modoImg });
  };

  handleInputTextChange = (e) => {
    let targetName = e.target.name,
      targetValue = e.target.value,
      muestraRemitente = { ...this.state.rel_remision_visita_muestra };

    switch (targetName) {
      case "marchamos":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.marchamos = targetValue.toUpperCase();
        break;
      /*case "no_recibo":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.no_recibo = targetValue.toUpperCase();
        break;*/
      case "fecha_remision":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.fecha_remision = targetValue;
        break;
      case "hora_remision":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.hora_remision = targetValue;
        break;
      case "fecha_vencimiento":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.fecha_vencimiento = targetValue;
        break;
      /*case "monto":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.monto = targetValue.toUpperCase();
        break;*/
      case "no_remision":
        if (this.checkPositiveIntegersWithZero(targetValue)) {
          this.cleanErrorsValidation(targetName);
          muestraRemitente.no_remision = targetValue;
        }
        break;
      case "id_mx":
        if (this.checkPositiveIntegersWithZero(targetValue)) {
          this.cleanErrorsValidation(targetName);
          muestraRemitente.id_mx = targetValue;
        }
        break;
      case "lote":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.lote = targetValue.toUpperCase();
        break;
      /*case "temperatura_levantamiento":
        if (this.validateFloat(targetValue)) {
          this.cleanErrorsValidation(targetName);
          muestraRemitente.temperatura_levantamiento =
            targetValue.toUpperCase();
        }
        break;*/
      case "no_muestras":
        if (this.checkPositiveIntegersWithoutZero(targetValue)) {
          this.cleanErrorsValidation(targetName);
          muestraRemitente.no_muestras = targetValue.toUpperCase();
        }
        break;
      case "proposito":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.proposito = targetValue.toUpperCase();
        break;
      case "clasificacion_zootecnica":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.clasificacion_zootecnica = targetValue.toUpperCase();
        break;
      /*case "temperatura_ingreso":
        if (this.validateFloat(targetValue)) {
          this.cleanErrorsValidation(targetName);
          muestraRemitente.temperatura_ingreso = targetValue.toUpperCase();
        }
        break;*/
      /*case "fecha_ingreso":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.fecha_ingreso = targetValue;
        break;*/
      /*case "hora_ingreso":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.hora_ingreso = targetValue;
        break;*/
      case "observaciones":
        muestraRemitente.observaciones = targetValue.toUpperCase();
        break;
      case "fecha_prod_elab":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.fecha_prod_elab = targetValue;
        break;
      /*case "no_solicitud":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.no_solicitud = targetValue.toUpperCase();
        break;*/
      case "comarca":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.comarca = targetValue.toUpperCase();
        break;
      case "otro_propietario":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.otro_propietario = targetValue.toUpperCase();
        break;
      case "cue_cod_ipsa":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.cue_cod_ipsa = targetValue.toUpperCase();
        break;
      case "lugar_muestreo":
        this.cleanErrorsValidation(targetName);
        muestraRemitente.lugar_muestreo = targetValue.toUpperCase();
        break;
      default:
        break;
    }

    this.setState({ rel_remision_visita_muestra: muestraRemitente });
  };

  //Funcion para cambiar de pagina en el grid de regente
  setVisitasPage = (page) => {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getVisitas?page=" + page + src).then((v) => {
      this.setState({
        visitas: v.data,
        paginas: v.last_page,
        registros: v.total,
        paginaActual: v.current_page,
        workingGrid: false,
      });
    });
  };

  // funcion para validar solo enteros positivos en un input
  checkPositiveIntegersWithZero = (str) => {
    let regex = /^([0-9]\d{0,50})$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  checkPositiveIntegersWithoutZero = (str) => {
    let regex = /^[1-9]\d{0,20}$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  handleVisitasPage = (e) => {
    this.setVisitasPage(e.target.value);
  };

  handleClick_v = (e) => {
    this.setState({
      previa: true,
      previa_url: Api.url + `app/visita/?id=${e.target.id}`,
    });
  };

  handleClick_vd = (e) => {
    this.setState({
      previa: true,
      previa_url: Api.url + `app/visita-archivo/?id=${e.target.id}`,
    });
  };

  render() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <Nav tabs={true}>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1",
                })}
                onClick={() => {
                  this.toggleTab("1");
                }}
              >
                <span className="d-sm-none">
                  VISITAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  VISITAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <div className="table-responsive">
                <fieldset>
                  <legend>Buscar visita</legend>

                  <div className="row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="folio">Folio:</label>
                        <div className="input-group">
                          <input
                            id="folio"
                            name="folio"
                            placeholder="Ingrese folio"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="folio_manual">Folio manual:</label>
                        <div className="input-group">
                          <input
                            id="folio_manual"
                            name="folio_manual"
                            onChange={this.handleSearch}
                            placeholder="Ingrese folio manual"
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="nombre_razon">
                          Nombre establecimiento:
                        </label>
                        <div className="input-group">
                          <input
                            id="nombre_razon"
                            name="nombre_razon"
                            onChange={this.handleSearch}
                            placeholder="Ingrese establecimiento"
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="actividad_id">Actividad:</label>
                        <div className="input-group">
                          <select
                            name="actividad_id"
                            id="actividad_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.cat_actividad.map((actividad) => (
                              <option key={actividad.id} value={actividad.id}>
                                {actividad.descripcion.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="pais_id">País:</label>
                        <div className="input-group">
                          <select
                            name="pais_id"
                            id="pais_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.opciones_pais.map((op) => (
                              <option key={op.id} value={op.id}>
                                {op.descripcion.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="departamento_id">Departamento:</label>
                        <div className="input-group">
                          <select
                            name="departamento_id"
                            id="departamento_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.locations.departamentos.map((dep) => (
                              <option key={dep.id} value={dep.id}>
                                {dep.name.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="municipio_id">Municipio:</label>
                        <div className="input-group">
                          <select
                            name="municipio_id"
                            id="municipio_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.municipios.map((mun) => (
                              <option key={mun.id} value={mun.id}>
                                {mun.name.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="estatus">Estado:</label>
                        <div className="input-group">
                          <select
                            name="estatus"
                            id="estatus"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            <option value="1">REGISTRADO</option>
                            <option value="2">NO REGISTRADO</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="tipo_visita">Tipo visita:</label>
                        <div className="input-group">
                          <select
                            name="tipo_encuesta_id"
                            id="tipo_encuesta_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.cat_tipo_encuesta
                              .sort((a, b) =>
                                a.descripcion.toUpperCase() >
                                b.descripcion.toUpperCase()
                                  ? 1
                                  : -1
                              )
                              .map((encuesta) => (
                                <option key={encuesta.id} value={encuesta.id}>
                                  {encuesta.descripcion.toUpperCase()}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-2">
                      <div className="form-group">
                        <label htmlFor="fecha">Fecha desde:</label>
                        <div className="input-group">
                          <input
                            type="date"
                            name="fecha"
                            onChange={this.handleSearch}
                            id="fecha"
                            className="form-control"
                            placeholder="Fecha"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-2">
                      <div className="form-group">
                        <label htmlFor="fecha2">Fecha hasta:</label>
                        <div className="input-group">
                          <input
                            type="date"
                            min={this.state.buscar["fecha"]}
                            name="fecha2"
                            onChange={this.handleSearch}
                            disabled
                            id="fecha2"
                            className="form-control"
                            placeholder="Fecha"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-2">
                      <div className="form-group">
                        <label htmlFor="search">&nbsp;</label>
                        <div className="input-group">
                          <button
                            type="button"
                            className="btn btn-orange w-100"
                            title="Buscar"
                            onClick={() => this.setVisitasPage(1)}
                          >
                            <i className="fa fa-search"></i> Buscar
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-2">
                      <div className="form-group">
                        <label htmlFor="search">&nbsp;</label>
                        <div className="input-group">
                          <button
                            type="button"
                            className="btn btn-blue w-100"
                            title="Limpiar"
                            onClick={this.cleanSearch}
                          >
                            <i className="fas fa-trash-alt"></i> Limpiar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Folio manual</th>
                      <th className="text-center">Establecimiento</th>
                      <th className="text-center">Actividad</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Locación</th>
                      <th className="text-center">Tipo</th>
                      <th className="text-center">Estado</th>
                      {/* <th></th>
                      <th></th>
                      <th></th> */}
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.visitas &&
                    Object.keys(this.state.visitas).length > 0 ? (
                      this.state.visitas.map((v) => (
                        <tr
                          key={v.id}
                          className={
                            v.dias > 15 && v.estatus === "En espera"
                              ? "alerta"
                              : ""
                          }
                        >
                          <td className="text-center">{v.folio}</td>
                          <td className="text-center">
                            {v.folio_manual ? v.folio_manual : "N/A"}
                          </td>
                          <td className="text-center">
                            {v.nombre_razon.toUpperCase()}
                          </td>
                          <td
                            className="text-center"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={
                              v.nombre_actividad ? v.nombre_actividad : "N/A"
                            }
                          >
                            {v.nombre_actividad
                              ? v.nombre_actividad.length > 22
                                ? v.nombre_actividad
                                    .substring(0, 30)
                                    .toUpperCase() + "..."
                                : v.nombre_actividad.toUpperCase()
                              : "N/A"}
                          </td>

                          <td className="text-center">
                            {/* {format(new Date(v.fecha), "dd/MM/yyyy")} */}
                            {v.fecha.split("-").reverse().join("/")}
                          </td>
                          <td className="text-center">
                            {!v.departamento_id
                              ? v.pais_texto.toUpperCase()
                              : `${v.nombre_municipio.toUpperCase()}, ${v.nombre_departamento.toUpperCase()}`}
                          </td>
                          <td
                            className="text-center"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={v.nombre_encuesta}
                          >
                            {[
                              "1",
                              "2",
                              "3",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                            ].includes(v.tipo_encuesta_id)
                              ? v.nombre_encuesta.slice(
                                  0,
                                  Math.round(v.nombre_encuesta.length) / 2
                                ) + "..."
                              : v.nombre_encuesta}
                          </td>
                          <td className="text-center">
                            {v.establecimiento_id == null
                              ? "NO REGISTRADO"
                              : "REGISTRADO"}
                          </td>
                          <td>
                            <UncontrolledDropdown>
                              <DropdownToggle style={{ background: "#0f9e3e" }}>
                                <i className="fas fa-bars"></i>
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem
                                  onClick={this.handleClick_v}
                                  id={v.id}
                                  data-encuesta={v.tipo_encuesta_id}
                                  title="Imprimir PDF"
                                  className="boton-encuesta"
                                >
                                  <i
                                    id={v.id}
                                    data-encuesta={v.tipo_encuesta_id}
                                    className="fas fa-file-pdf"
                                  ></i>{" "}
                                  Ver PDF
                                </DropdownItem>
                                <DropdownItem
                                  onClick={this.openCarousel}
                                  id={v.id}
                                  data-encuesta={v.tipo_encuesta_id}
                                  data-folio={v.folio}
                                  title="Ver Imágenes capturadas durante la visita"
                                  className="boton-encuesta"
                                >
                                  <i
                                    id={v.id}
                                    data-encuesta={v.tipo_encuesta_id}
                                    data-folio={v.folio}
                                    className="fas fa-camera"
                                  ></i>{" "}
                                  Ver Fotos
                                </DropdownItem>

                                {!v.url_pdf ? (
                                  <DropdownItem
                                    onClick={this.modalInputFile}
                                    id={v.id}
                                    data-encuesta={v.tipo_encuesta_id}
                                    data-folio={v.folio}
                                    title="Adjuntar Documento"
                                    className="boton-encuesta"
                                  >
                                    <i
                                      id={v.id}
                                      onClick={this.modalInputFile}
                                      data-encuesta={v.tipo_encuesta_id}
                                      data-folio={v.folio}
                                      className="fas fa-paperclip"
                                    ></i>{" "}
                                    Adjuntar Documento
                                  </DropdownItem>
                                ) : (
                                  <DropdownItem
                                    onClick={this.handleClick_vd}
                                    id={v.id}
                                    data-encuesta={v.tipo_encuesta_id}
                                    data-folio={v.folio}
                                    title="Ver documento adjunto"
                                    className="boton-encuesta"
                                  >
                                    <i
                                      id={v.id}
                                      data-encuesta={v.tipo_encuesta_id}
                                      data-folio={v.folio}
                                      className="fas fa-file-signature"
                                    ></i>{" "}
                                    Ver documento adjunto
                                  </DropdownItem>
                                )}

                                <DropdownItem divider />
                                {["8", "9", "10"].includes(
                                  v.tipo_encuesta_id
                                ) ? (
                                  !v.remision_muestra_id ? (
                                    <>
                                      <DropdownItem
                                        onClick={this.openModalMuestraForm}
                                        id={v.id}
                                        data-encuesta={v.tipo_encuesta_id}
                                        data-folio={v.folio}
                                        title="Llenar formulario de remisión de muestra"
                                        className="muestra-form-btn"
                                      >
                                        <i
                                          id={v.id}
                                          data-encuesta={v.tipo_encuesta_id}
                                          data-folio={v.folio}
                                          className="fas fa-file-signature"
                                        ></i>{" "}
                                        Formulario de Remisión
                                      </DropdownItem>
                                      <DropdownItem divider />
                                    </>
                                  ) : (
                                    <>
                                      <DropdownItem
                                        onClick={this.handleClick_hmr}
                                        id={v.id}
                                        data-folio={v.folio}
                                        title="Ver hoja de remisión de muestra"
                                        className="muestra-form-btn"
                                      >
                                        <i
                                          id={v.id}
                                          data-folio={v.folio}
                                          className="fas fa-file-alt"
                                        ></i>{" "}
                                        Ver Hoja de Remisión
                                      </DropdownItem>
                                      <DropdownItem divider />
                                    </>
                                  )
                                ) : null}
                                <DropdownItem
                                  onClick={this.desactivarVisita}
                                  id={v.id}
                                  data-folio={v.folio}
                                  title="Desactivar visita"
                                  className="boton-encuesta"
                                >
                                  <i
                                    id={v.id}
                                    data-folio={v.folio}
                                    className="fas fa-trash-alt"
                                  ></i>{" "}
                                  Eliminar
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          <b>No se encontraron registros</b>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setVisitasPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.setVisitasPage(this.state.paginaActual - 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.setVisitasPage(this.state.paginaActual + 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setVisitasPage(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleVisitasPage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
          </TabContent>

          <Modal
            isOpen={this.state.modalMuestraState}
            tabIndex="-1"
            style={{
              maxWidth: "100%",
              width: "80%",
            }}
          >
            <ModalHeader
              width="100%"
              toggle={this.handleModalMuestraFormCloseBtn}
              className="text-center"
            >
              Folio: {this.state.folio_visita}
            </ModalHeader>
            <ModalBody>
              <form
                id="special-cases"
                onSubmit={this.handleEstablishmentSubmit}
              >
                <MuestraForm
                  workingModal={this.state.workingModal}
                  state={this.state}
                  handleLaboratoryChange={this.handleLaboratoryChange}
                  handleInputTextChange={this.handleInputTextChange}
                  handleEstablecimientoChange={this.handleEstablecimientoChange}
                  handleModalFormCloseBtn={this.handleModalFormCloseBtn}
                />
              </form>
            </ModalBody>
            <ModalFooter>
              <div className="btn-group">
                <button
                  className="btn btn-danger mr-1"
                  onClick={this.handleModalMuestraFormCloseBtn}
                >
                  Regresar
                </button>
                <button
                  onClick={this.handleSubmitMuestraRemision}
                  value="5"
                  id="aprobar_form"
                  className="btn btn-success pull-right"
                >
                  Aceptar
                </button>
              </div>
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={this.state.openCarousel}
            id="modal-carousel"
            tabIndex="-1"
            style={{
              maxWidth: "80%",
              width: "45%",
              marginRight: "auto",
              marginLeft: "auto",
            }}
          >
            <ModalHeader width="100%" className="text-center">
              Folio: {this.state.folio_visita}
            </ModalHeader>
            <ModalBody>
              <FotosVisita
                workingModal={this.state.workingModal}
                state={this.state}
              />
            </ModalBody>
            <ModalFooter>
              <div className="btn-group">
                <button
                  id="rotacion-img-btn"
                  className="btn btn-white"
                  onClick={this.orientarImagen}
                >
                  Ver Imágen Horizontal
                </button>
                <button
                  className="btn btn-primary  ml-2"
                  onClick={this.closeCarousel}
                >
                  Regresar
                </button>
              </div>
            </ModalFooter>
          </Modal>

          <div className={this.state.previa ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              className="rounded"
              src={this.state.previa_url}
              loading="eager"
            ></iframe>
            <center>
              <div className="btn-group">
                <button
                  onClick={() => {
                    this.setState({ previa: false });
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </button>
                <a
                  className="btn btn-primary"
                  href={this.state.previa_url + "&download=1"}
                  download="download"
                >
                  Descargar
                </a>
              </div>
            </center>

            <HojaRemisionMuestra
              workingModal={this.state.workingModal}
              remisionMuestra={this.state.remisionMuestra}
              folio_visita={this.state.folio_visita}
              handleModalFormCloseBtn={this.handleModalFormCloseBtn}
              modalHojaRemisionMuestra={this.state.modalHojaRemisionMuestra}
              closeModalHojaRemision={this.closeModalHojaRemision}
              change={this.handleCloseModalCE}
            ></HojaRemisionMuestra>
          </div>
        </div>
      </div>
    );
  }
}

export default Visits;
